<template>
  <div class="EduTaxRebateWidgetGovMB__container" v-if="loaded">
    <div v-if="false">
    <button type="button" style="position:absolute; z-index:9999" @click="$router.push('texts')">Texts</button>
  </div>
    <div class="EduTaxRebateWidgetGovMB__header">
      <div class="EduTaxRebateWidgetGovMB__headerIcon"><img src="@/assets/img/header-icon.png" alt=""/></div>
      <div class="EduTaxRebateWidgetGovMB__headerTitle" v-html="$t('headerTitle')"></div>
      <div class="EduTaxRebateWidgetGovMB__headerIntro" v-html="$t('headerIntro')"></div>
      <div v-if="false" class="EduTaxRebateWidgetGovMB__headerBody" v-html="$t('headerBody')"></div>
    </div>
    <div class="EduTaxRebateWidgetGovMB__body">
      <div class="EduTaxRebateWidgetGovMB__box">
        <div class="EduTaxRebateWidgetGovMB__boxBorder">
        <div class="EduTaxRebateWidgetGovMB__boxHeader">
          <div class="EduTaxRebateWidgetGovMB__boxHeaderTitleWrapper">
            <span class="EduTaxRebateWidgetGovMB__boxHeaderTitle" v-html="$t('boxHeaderTitle')"></span>
              <span v-if="false" class="EduTaxRebateWidgetGovMB__boxHeaderTitleButton" :v-show="true">
                <button class="EduTaxRebateWidgetGovMB__tooltipButton" type="button" v-tooltip="{
                content: $t('help'),
                placement: 'top-center',
                trigger:'hover click',
                classes: ['info'],
                offset: 10,
                autoHide:false
              }"><span>?</span></button>
            </span>

          </div>
        </div>
        <div class="EduTaxRebateWidgetGovMB__boxSubHeader">
          <div class="EduTaxRebateWidgetGovMB__boxSubHeaderTitle"  v-html="$t('boxSubHeaderTitle')"></div>
          <div class="EduTaxRebateWidgetGovMB__boxSubHeaderSubTitle" v-html="$t('boxSubHeaderSubTitle')">
          </div>
        </div>


        <div class="EduTaxRebateWidgetGovMB__boxBody">

          <div class="EduTaxRebateWidgetGovMB__formSection">
            <div class="EduTaxRebateWidgetGovMB__propertyColumn">
              <div class="EduTaxRebateWidgetGovMB__properties">
                <property-form v-model="model.property"></property-form>
            </div>
            <div class="EduTaxRebateWidgetGovMB__submit">
              <div :class="'EduTaxRebateWidgetGovMB__summaryTitle EduTaxRebateWidgetGovMB__summaryTitle__'+$store.state.lang" type="button" @click="onSubmit()"><img v-if="false" src="@/assets/img/calculate-icon.png" alt=""/><span v-html="$t('calculate')"></span></div>
            </div>
          </div>
        </div>
        <a class="scroll-to-me" id="scrol-to-me"></a>

<div v-show="hasData" class="EduTaxRebateWidgetGovMB__summary">
      <property-summary v-model="model.property"></property-summary>
</div>


<div v-if="true" class="EduTaxRebateWidgetGovMB__disclaimerSection">
  <div class="EduTaxRebateWidgetGovMB__disclaimer" v-html="$t('disclaimer')">
  </div>
</div>


</div>
<div class="EduTaxRebateWidgetGovMB__boxFooter">
  <div v-html="getLastUpdated"></div>
</div>
</div>
</div><!-- end of box -->
</div>
<div class="EduTaxRebateWidgetGovMB__footer">
</div>

</div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import Format from '../utility/Format'
import numeral from 'numeral'
import Property from '../models/Property'
import Assessment from '../models/Assessment'
import PropertyForm from '../components/PropertyForm'
import PropertySummary from '../components/PropertySummary'

export default {
  data () {
    return {
      model: {
        property: [],
        totalRebate:0,
      },
      Format,
      fullVersion:true,
      loaded:false,
      renderCount:0,
      showEstimate: true,
    }
  },
  components: {
    PropertyForm,
    PropertySummary,
 },
 methods: {
  ...mapMutations([
  ]),

  scrollToResults() {
    const el = this.$el.getElementsByClassName('scroll-to-me')[0];

    if (el) {
      // Use el.scrollIntoView() to instantly scroll to the element
      el.scrollIntoView({behavior: 'smooth'});
    }
  },

  formatNumber(num) {
    return numeral(num).format();
  },

  formatDollars(num) {
    return numeral(num).format();
  },

  getParsedString(val) {
    let text = ""+val;
    return text.formatUnicorn(this.model.group[this.$store.state.lang].barLabel, numeral(this.model.group.uptakePopulation).format(),numeral(this.model.group.totalImmunized).format(), numeral(this.model.queueStart).format(), numeral(this.model.queueEnd).format(),     numeral(this.model.group.dosesAllocated).format("0,0"),numeral(this.model.group.ahead).format("0,0"),this.model.uptakePercentage,numeral(this.model.group.aheadUpper).format("0,0"));
  },

  onPropertyAdd() {
    this.model.property.push(new Property());
  },
  onPropertyRemove(i) {
    this.model.property.splice(i, 1);
  },

  onAssessmentAdd(i) {
    let classType = "residential1";
    let millRate = 0;
    // if (this.model.property[i].assessment.length > 0) {
      // let lastType = this.model.property[i].assessment[this.model.property[i].assessment.length-1].classType;
      // millRate = this.model.property[i].assessment[this.model.property[i].assessment.length-1].schoolDivisionMillRate.value;
      // if (lastType == "residential1" || lastType == "residential2" || lastType == "residential3") {
      //   	classType = "farmProperty";
      // }
      // if (lastType == "residential2") {
      //     classType = "residential3";
      // }
      // if (lastType == "residential3") {
      //     classType = "farmProperty";
      // }
      // if (lastType == "farmProperty") {
      //     classType = "otherProperty";
      // }
      // if (lastType == "otherProperty") {
      //     classType = "otherProperty";
      // }
    // }
      this.model.property[i].assessment.push(new Assessment({
       classType:classType,
       schoolDivisionMillRate:millRate,
      }));
  },
  onAssessmentRemove(i, j) {
    this.model.property[i].assessment.splice(j, 1);
  },


	onSubmit() {

      this.$nextTick(() => {
      });

    }
  },
  computed: {
    ...mapGetters([
    ]),

    hasData() {
      if (this.model.property.length == 0) {
        return false;
      }
      return true;
    },

  getHeaderIntro() {
    if (this.loaded) {
      return this.$t("headerIntro");
    }
    return null;
  },

  getHeaderSubtitle() {
    if (this.loaded) {
      return this.$t("headerSubtitle");
    }
    return null;
  },



  getLastUpdated() {
    return null;
  },



},
created () {
  if (this.$store.state.lang == "fr") {
    numeral.locale('fr');
  } else {
    numeral.locale('en');
  }

  window.$bus.$on('property:remove', this.onPropertyRemove);
  window.$bus.$on('property:add', this.onPropertyAdd);

  window.$bus.$on('assessment:remove', this.onAssessmentRemove);
  window.$bus.$on('assessment:add', this.onAssessmentAdd);

},
watch: {


},
mounted () {

  if (this.$store.state.lang == "fr") {
    this.$moment().locale(this.$store.state.lang + "-88591");
  } else {
    this.$moment().locale(this.$store.state.lang + "-ca");
  }
  this.model.property.push(new Property({rollNumber:""}));
  this.loaded = true;
}
}
</script>

<style lang="scss" scoped>
@import '../scss/_index';
$label-color: red;
// @import "../../node_modules/vue-custom-range-slider/dist/vue-custom-range-slider.css";
@import "../../node_modules/vue-horizontal-scroll/dist/vue-horizontal-scroll.css";



.slider {
  z-index:0;
  ::v-deep .slider__label {
    font-family:$number-font;
    position:absolute;
    top: 3px;
    border: 4px solid $blue;
    border-radius: 50%;
    background: transparent;
    color:$blue;
    z-index:1;
  }
  ::v-deep .slider__track {
    width:100%;
    position:absolute;
    z-index:0;
    height:5px;
    color:$blue;
  }
  ::v-deep .slider__label:after {
    top:20px;
    bottom:0px;
    color:$blue;
    background:transparent;
  }
  ::v-deep  .slider__input {
    background:transparent;
  }
  ::v-deep  .slider__input::range-thumb {
    height:30px;
    width:30px;
    background:transparent;
    border-radius:50%;
    cursor:pointer;
    border:none;
  }
}

</style>

